import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { withRouter } from 'react-router';
import ParadexAccount from './paradex-account/paradex-account';
import RFQ from './rfq/rfq';
import paradexContext from '../../stores/paradex-store';
import { useTabQueryString } from '../../hooks/use-tab-query-string';

const useStyles = makeStyles({
  tabs: {
    paddingBottom: 20,
  },
  tab: {
    width: 220,
  },
});

const ParadexGroup = ({ location, history }) => {
  const classes = useStyles();
  const paradex = React.useContext(paradexContext);
  const { tab, setTab } = useTabQueryString('options');

  React.useEffect(() => {
    paradex.fetch();
  }, [paradex]);

  return (
    <div data-testid="paradex">
      <Tabs
        value={tab}
        onChange={(_, selectedTab) => setTab(selectedTab)}
        className={classes.tabs}
      >
        <Tab value="options" className={classes.tab} label="RFQ" />
        <Tab value="account" className={classes.tab} label="Account" />
      </Tabs>
      {tab === 'options' && <RFQ source={paradex} />}
      {tab === 'account' && <ParadexAccount source={paradex} />}
    </div>
  );
};

export default withRouter(ParadexGroup);
